module.exports = __webpack_public_path__ + "img/IMG_8157.4fb2e33a.jpg";